<template>
  <VueAgile ref="carousel" class="onboarding-view" :options="carouselSettings">
    <div class="slide" @click="goToNextSlide">
      <h1 class="header-message">{{ $t('welcome-message') }}</h1>
      <h1 class="header-message">
        <FontAwesomeIcon icon="arrow-right" />
      </h1>
    </div>
    <div class="slide" @click="goToNextSlide">
      <h1 class="header-message">{{ $t('introduction') }}</h1>
      <h1 class="header-message">
        <FontAwesomeIcon icon="arrow-right" />
      </h1>
    </div>
    <div class="slide" @click="goToNextSlide">
      <div>
        <h1 class="header-message action-word">{{ $t('step-1-action') }}</h1>
        <span class="explanation">{{ $t('step-1-message') }}</span>
      </div>
      <div>
        <h1 class="header-message action-word">{{ $t('step-2-action') }}</h1>
        <span class="explanation">{{ $t('step-2-message') }}</span>
      </div>
      <div>
        <h1 class="header-message action-word">{{ $t('step-3-action') }}</h1>
        <span class="explanation">{{ $t('step-3-message') }}</span>
      </div>
      <h1 class="header-message">
        <FontAwesomeIcon icon="arrow-right" />
      </h1>
    </div>
    <div class="slide">
      <h2>{{ $t('last-page-message') }}</h2>
      <div class="action-buttons">
        <!-- <RecycoButton @click.native="goToSignup" class="signup-button" colorStyle="inverted">{{ $t('sign-up') }}</RecycoButton>
        <router-link :to="{ name: 'login' }" class="login-link">{{ $t('log-in-with-existing-account') }}</router-link> -->
        <RecycoButton @click.native="authenticate" class="signup-button" colorStyle="inverted">{{ $t('start') }}</RecycoButton>
      </div>
    </div>
    <template slot="prevButton">
      <FontAwesomeIcon icon="chevron-left" />
    </template>
    <template slot="nextButton">
      <FontAwesomeIcon icon="chevron-right" />
    </template>
  </VueAgile>
</template>

<i18n>
  {
    "es": {
      "welcome-message": "Bienvenido a recyco.in...",
      "introduction": "...donde tus reciclables ♻️ se convierten en beneficios para vos y el medio ambiente",
      "step-1-action": "Recolectá",
      "step-1-message": " tus envases plásticos",
      "step-2-action": "Canjeá",
      "step-2-message": "los envase por monedas en nuestros puntos limpios",
      "step-3-action": "Disfrutá",
      "step-3-message": "de los beneficios",
      "last-page-message": "Empezá a sumar 😁",
      "sign-up": "Creá tu cuenta",
      "log-in-with-existing-account": "o ingresá con una cuenta existente",
      "start": "Quiero Empezar",
      "log-in-error": "Se produjo un error al intentar ingresar a tu cuenta"
    },
    "en": {
      "welcome-message": "Welcome to Recyco...",
      "introduction": "...where yout recyclables ♻️ are turned into benefits for you and the environment",
      "step-1-action": "Collect",
      "step-1-message": "your plastic packaging",
      "step-2-action": "Exchange",
      "step-2-message": "the packaging for coins at our Recyco stations",
      "step-3-action": "Enjoy",
      "step-3-message": "the benefits",
      "last-page-message": "Start collecting 😁",
      "sign-up": "Create an account",
      "log-in-with-existing-account": "or sign in with an existing account",
      "start": "I Want to Start",
      "log-in-error": "An error ocurred while trying to log you in"
    }
  }
</i18n>

<script>
  // eslint-disable-next-line
  import { VueAgile } from 'vue-agile';
  import { RecycoButton } from '@/components/recyco';

  export default {
    name: 'oboarding-view',
    components: {
      VueAgile,
      RecycoButton,
    },
    data() {
      return {
        carouselSettings: {
          infinite: false,
          navButtons: false,
        },
      };
    },
    methods: {
      goToSignup() {
        this.$router.push({ name: 'signup' });
      },
      goToNextSlide() {
        this.$refs.carousel.goToNext();
      },
      async authenticate() {
        try {
          await this.$auth.loginWithPopup();
          this.$router.push({ name: 'balance' });
        } catch (err) {
          alert(this.$t('log-in-error'));
          console.error(err);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .onboarding-view {
    overflow: hidden;
    padding-bottom: 2em;

    background-color: var(--color-primary);
    color: var(--color-background);

    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .slide {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    height: 80vh;

    padding: 1em;
    box-sizing: border-box;
  }

  .action-word {
    margin-bottom: 0em;
  }

  .explanation {
    font-size: 1.5em;
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
  }

  .signup-button {
    font-size: 1.5em;
  }

  .login-link {
    margin-top: 1em;

    color: inherit;
    // font-size: 0.75em;
  }
</style>

<style lang="scss">
  .agile {
    &__actions {
      // margin-top: 1em;
      justify-content: center; // TODO remove this line if it is decided to add navigation buttons
    }

    &__nav-button {
      background: transparent;
      border: none;
      color: var(--color-background);
      cursor: pointer;
      font-size: 1.5em;
      transition-duration: .3s;

      &:hover {
        filter: opacity(0.5);
      }
    }

    &__dot {
      --dot-size: 0.5rem;
      margin: 0 var(--dot-size);

      button {
        background-color: var(--color-background);
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        width: var(--dot-size);
        height: var(--dot-size);
        font-size: 0;
        line-height: 0;
        margin: 0;
        padding: 0;
        transition-duration: .3s;
        filter: opacity(0.5);
      }

      &--current, &:hover {
        button {
          filter: opacity(1);
        }
      }
    }
  }
</style>
